import { render, staticRenderFns } from "./SfxIconHorizontalMore.vue?vue&type=template&id=31139e80&"
import script from "./SfxIconHorizontalMore.vue?vue&type=script&lang=js&"
export * from "./SfxIconHorizontalMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports